import { useEffect } from 'react';

const useResetUrl = () => {
 
   // alert("useResetUrl");
    window.history.replaceState({}, document.title, '/');
 
};

export default useResetUrl;
